var _circle, _mask, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.912,
    cy: 16.151,
    r: 15.5,
    fill: "#D8D1FA",
    stroke: "#CEC7F1"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "avatar-03_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 29,
    height: 29
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.912,
    cy: 16.151,
    r: 13.5,
    fill: "#D8D1FA",
    stroke: "#BAB2E2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#avatar-03_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 32V23.25l-.042-3.864v-3c0-2.466-1-4.686-2.625-6.289a8.988 8.988 0 00-6.5-2.589C11.917 7.59 8 11.7 8 16.59V32h18z",
    fill: "#A294E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
    fill: "#8D80CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 21.573v.164C22 23.721 19.31 25 17 25c-2.32 0-5-1.252-5-3.263v-.163c0-.22.23-.368.459-.368 0 0 1.926.794 4.541.794s4.541-.794 4.541-.794c.23-.036.459.147.459.367z",
    fill: "#8E81CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.345 15.36l-1.425 1.015 1.425.985",
    stroke: "#8D80CB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.851s1 .15 2 .15 2-.15 2-.15V26a2 2 0 01-4 0v-4.149z",
    fill: "#7D70BE"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzMiIHZpZXdCb3g9IjAgMCAzMyAzMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYuOTExNyIgY3k9IjE2LjE1MDkiIHI9IjE1LjUiIGZpbGw9IiNEOEQxRkEiIHN0cm9rZT0iI0NFQzdGMSIvPgo8bWFzayBpZD0ibWFzazAiIG1hc2stdHlwZT0iYWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjIiIHk9IjIiIHdpZHRoPSIyOSIgaGVpZ2h0PSIyOSI+CjxjaXJjbGUgY3g9IjE2LjkxMTciIGN5PSIxNi4xNTA5IiByPSIxMy41IiBmaWxsPSIjRDhEMUZBIiBzdHJva2U9IiNCQUIyRTIiLz4KPC9tYXNrPgo8ZyBtYXNrPSJ1cmwoI21hc2swKSI+CjxwYXRoIGQ9Ik0yNiAzMi4wMDAxVjIzLjI0ODZMMjUuOTU4MyAxOS4zODUyVjE2LjM4NDlDMjUuOTU4MyAxMy45MTg4IDI0Ljk1ODMgMTEuNjk5NCAyMy4zMzMzIDEwLjA5NjVDMjEuNjY2NyA4LjQ1MjUyIDE5LjM3NSA3LjQ2NjEyIDE2LjgzMzMgNy41MDcyMkMxMS45MTY3IDcuNTg5NDIgNy45OTk5OCAxMS42OTk0IDcuOTk5OTggMTYuNTkwNFYyMi4zODU1VjMyLjAwMDFIMjZaIiBmaWxsPSIjQTI5NEU0Ii8+CjxwYXRoIGQ9Ik0xMy41IDE4QzE0LjMyODQgMTggMTUgMTcuMzI4NCAxNSAxNi41QzE1IDE1LjY3MTYgMTQuMzI4NCAxNSAxMy41IDE1QzEyLjY3MTUgMTUgMTIgMTUuNjcxNiAxMiAxNi41QzEyIDE3LjMyODQgMTIuNjcxNSAxOCAxMy41IDE4WiIgZmlsbD0iIzhEODBDQiIvPgo8cGF0aCBkPSJNMjIgMjEuNTczNVYyMS43MzdDMjIgMjMuNzIwOCAxOS4zMDk0IDI1IDE3IDI1QzE0LjY3OTEgMjUgMTIgMjMuNzQ4IDEyIDIxLjczN1YyMS41NzM1QzEyIDIxLjM1MzMgMTIuMjI5MyAyMS4yMDY1IDEyLjQ1ODcgMjEuMjA2NUMxMi40NTg3IDIxLjIwNjUgMTQuMzg1MyAyMiAxNyAyMkMxOS42MTQ2IDIyIDIxLjU0MTMgMjEuMjA2NSAyMS41NDEzIDIxLjIwNjVDMjEuNzcwNiAyMS4xNjk4IDIyIDIxLjM1MzMgMjIgMjEuNTczNVoiIGZpbGw9IiM4RTgxQ0IiLz4KPHBhdGggZD0iTTIxLjM0NSAxNS4zNTk2TDE5LjkyMDEgMTYuMzc0NUwyMS4zNDUgMTcuMzU5NiIgc3Ryb2tlPSIjOEQ4MENCIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8cGF0aCBkPSJNMTUgMjEuODUxMUMxNSAyMS44NTExIDE2IDIyLjAwMDEgMTcgMjIuMDAwMUMxOCAyMi4wMDAxIDE5IDIxLjg1MTEgMTkgMjEuODUxMVYyNkMxOSAyNy4xMDQ2IDE4LjEwNDUgMjggMTcgMjhDMTUuODk1NCAyOCAxNSAyNy4xMDQ2IDE1IDI2VjIxLjg1MTFaIiBmaWxsPSIjN0Q3MEJFIi8+Cjwvc3ZnPgo=";
export { SvgAvatar03 as ReactComponent };